import { Button, Input } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";

type CatalogBrandsSearch = {
  limit?: number;
  offset?: number;
  search?: string;
};

export function CatalogBrandsFilter() {
  const nav = useNavigate({ from: "/app/catalog/brands" });
  const search = useSearch({
    from: "/app/catalog/brands",
  }) as CatalogBrandsSearch;

  const update = (updates: Partial<CatalogBrandsSearch>) => {
    nav({
      search: {
        limit: search.limit ?? 20,
        offset: 0,
        search: search.search,
        ...updates,
      },
    });
  };

  const hasFilter =
    typeof search.search === "string" && search.search.trim() !== "";

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 px-2">
      <Input
        placeholder="ຄົ້ນຫາຕາມຊື່ແບຣນດ໌..."
        value={search.search ?? ""}
        onChange={(e) => update({ search: e.target.value || undefined })}
        className="h-8 w-56"
      />
      {hasFilter && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => update({ search: undefined })}
        >
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
